import { getUserData } from "../utils/common";

export const useParamters = (pramaterCodes: string[]) => {
    const userData = getUserData();
    const parameterData = userData.Parameter;
    let parameter: any = [];

    for (let i = 0; i < parameterData.length; i++) {
        for (let j = 0; j < pramaterCodes.length; j++) {
            if (parameterData[i].paraCode === pramaterCodes[j]) {
                parameter.push(parameterData[i]);
            }
        }
    }

    return parameter;
};


export const useConvertMinutesSeconds = (time: any) => {
    const minutes = time / 60;
    const convertMinutesTostring = minutes.toString()?.split(".")[0];
    const mualtipleableValue = minutes.toString()?.split(".").length > 1 ? Number(convertMinutesTostring) : Number(convertMinutesTostring) - 1
    const second = time - (mualtipleableValue * 60);

    return { convertedminutes: mualtipleableValue, convertedseconds: second }
}